// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"_3TM8w","effectsGrayscale30":"kZBPk","resetList":"_34ngh","wrapper":"_2lwGe","image":"_2lrwQ","isPlaceholder":"_2zgnE","isCinema":"_3idjn"};